import React from 'react';
import cx from 'classnames';
import styles from './Logo.module.scss';
import { LogoPrimary } from './LogoPrimary';
import { LogoOptimised } from './LogoOptimised';
/**
 * @tdr
 */
export var Logo = function (_a) {
    var className = _a.className, optimised = _a.optimised, _b = _a.theme, theme = _b === void 0 ? 'green' : _b, width = _a.width;
    var Component = optimised ? LogoOptimised : LogoPrimary;
    var classNames = cx(className, styles[theme]);
    return React.createElement(Component, { className: classNames, width: width });
};
//# sourceMappingURL=Logo.js.map